export default __webpack_public_path__ + "static/media/MediaKitImg.1db75607.svg";